import getApiCall from "./getApiCall";

export const  AppendBlobWithToken =async(blobUrl)=>{
const response = await getApiCall(`common/upload/blob/admin/sas-token?url=${encodeURIComponent(blobUrl.split("?")[0])}`)
if(response.meta.status){
return response.data.url
}
else {
    return blobUrl
}
}